<template>
  <div class="kszp-main">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="重复考试">
              <el-select v-model="searchForm.dIsrepeat" clearable style="width: 100px">
                <el-option label="不允许" :value="0"></el-option>
                <el-option label="允许" :value="1"></el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item label="及时纠错">-->
<!--              <el-select v-model="searchForm.dIscorerr" clearable style="width: 100px">-->
<!--                <el-option label="关闭" :value="0"></el-option>-->
<!--                <el-option label="开启" :value="1"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="记分类型">
              <el-select v-model="searchForm.dKeeptype" clearable style="width: 100px">
                <el-option label="记最高分" :value="0"></el-option>
                <el-option label="记最新分" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="指派类型">
              <el-select v-model="searchForm.dAssign" clearable style="width: 100px">
                <el-option label="不指派" :value="0"></el-option>
                <el-option label="全员" :value="1"></el-option>
                <el-option label="指定人员" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加考试任务</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                label="考试任务"
                min-width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{scope.row.d_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="有效期"
                align="center"
                width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.d_starttime!=0&&scope.row.d_endtime!=0">{{scope.row.d_starttime}}至{{scope.row.d_endtime}}</div>
                  <div v-if="scope.row.d_starttime==0&&scope.row.d_endtime==0">不限</div>
                </template>
              </el-table-column>
              <el-table-column
                label="考试时长"
                align="center"
                width="100">
                <template slot-scope="scope">
                  <div>{{scope.row.d_duration}}分钟</div>
                </template>
              </el-table-column>
              <el-table-column
                label="重复考试"
                align="center"
                width="80">
                <template slot-scope="scope">
                  <i class="el-icon-success" v-if="scope.row.d_isrepeat===1" style="color: #67C23A"></i>
                  <i class="el-icon-error" v-if="scope.row.d_isrepeat===0" style="color: #f56c6c"></i>
                </template>
              </el-table-column>
<!--              <el-table-column-->
<!--                label="及时纠错"-->
<!--                align="center"-->
<!--                width="80">-->
<!--                <template slot-scope="scope">-->
<!--                  <i class="el-icon-success" v-if="scope.row.d_iscorerr===1" style="color: #67C23A"></i>-->
<!--                  <i class="el-icon-error" v-if="scope.row.d_iscorerr===0" style="color: #f56c6c"></i>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column
                label="考试难度"
                align="center"
                width="80">
                <template slot-scope="scope">
                  <span style="color:#E6A23C;"><i class="el-icon-star-on"></i> {{scope.row.d_difficult}}.0</span>
                </template>
              </el-table-column>
              <el-table-column
                label="及格线"
                align="center"
                width="80">
                <template slot-scope="scope">
                  <div>{{scope.row.d_passline}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="计分类型"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.d_keeptype===0">记最高分</span>
                  <span v-if="scope.row.d_keeptype===1">记最新分</span>
                </template>
              </el-table-column>
              <el-table-column
                label="指派类型"
                align="center"
                width="100">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.d_assign===0" :disable-transitions="true" size="mini" type="info">不指派</el-tag>
                  <el-tag v-if="scope.row.d_assign===1" :disable-transitions="true" size="mini">全员</el-tag>
                  <el-tag v-if="scope.row.d_assign===2" :disable-transitions="true" size="mini" type="danger">指定人员</el-tag>
                  <el-tag v-if="scope.row.d_assign===3" :disable-transitions="true" size="mini" type="warning">部门</el-tag>
                  <el-tag v-if="scope.row.d_assign===4" :disable-transitions="true" size="mini" type="success">职位</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="添加时间"
                align="center"
                width="170">
                <template slot-scope="scope">
                  <div>{{scope.row.d_time}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="应考人数"
                fixed="right"
                width="90">
                <template slot-scope="scope">
                  <span style="color: #f56c6c;font-weight: bold;margin-left: 10px"><i class="el-icon-user-solid"></i> {{scope.row.d_should}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="已考人数"
                fixed="right"
                width="90">
                <template slot-scope="scope">
                  <span style="color: #409eff;font-weight: bold;margin-left: 10px"><i class="el-icon-s-order"></i> {{scope.row.d_already}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="合格人数"
                fixed="right"
                width="90">
                <template slot-scope="scope">
                  <span style="color: #67C23A;font-weight: bold;margin-left: 10px"><i class="el-icon-success"></i> {{scope.row.d_pass}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="230"
                align="center"
                fixed="right">
                <template slot-scope="scope">
<!--                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>-->
<!--                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>-->
                  <el-button  size="mini" @click.stop="view(scope.row)" icon="el-icon-search">查看详情</el-button>
                  <el-dropdown size="mini"  @click.stop="editRow(scope.row)" split-button icon="el-icon-edit">
                    <i class="el-icon-edit"></i> 编辑
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="deleteRow(scope.row)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="editFormLoading">
        <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="rules">
          <el-form-item label="任务名称" prop="dName">
            <el-input v-model="editForm.dName" maxlength="100" placeholder="请输入任务名称" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="有效期限制" prop="radio">
            <el-radio v-model="radio" :label="0">不限</el-radio>
            <el-radio v-model="radio" :label="1">限制</el-radio>
          </el-form-item>
          <el-form-item label="有效期" prop="timeSE"  v-if="radio==1">
            <el-date-picker
              v-model="editForm.timeSE"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="有效期起"
              end-placeholder="有效期止">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="考试时长" prop="dDuration">
            <el-input-number v-model="editForm.dDuration" :min="1" :max="999" ></el-input-number>（分钟）
          </el-form-item>
          <el-form-item label="选择试卷" prop="dPaperid">
            <PaperSelect v-model="editForm.dPaperid" :oldPaperid="editForm.oldPaperid" :delid="user.delid" :role="1" :key="paperKey"></PaperSelect>
          </el-form-item>
          <el-form-item label="重复考试" prop="dIsrepeat">
            <el-radio v-model="editForm.dIsrepeat" :label="0">不允许</el-radio>
            <el-radio v-model="editForm.dIsrepeat" :label="1">允许</el-radio>
            <span style="font-size: 12px;color:#9aaabf" >
              <i class=" el-icon-info"></i> 温馨提示：
              <span>允许后学员在有效期内可以进行多次重考</span>
            </span>
          </el-form-item>
          <el-form-item label="记分类型" prop="dKeeptype">
            <el-select v-model="editForm.dKeeptype"  style="width: 100%">
              <el-option label="记最高分（全部考试里最高的得分记为考试结果）" :value="0"></el-option>
              <el-option label="记最新分（最后一次考试的得分记为考试结果）" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指派类型" prop="dAssign">
            <el-radio v-model="editForm.dAssign" :label="0">不指派</el-radio>
            <el-radio v-model="editForm.dAssign" :label="1">全员</el-radio>
            <el-radio v-model="editForm.dAssign" :label="2">指定人员</el-radio>
          </el-form-item>
          <el-form-item label="指定人员" prop="dealerIdData"  v-if="editForm.dAssign==2">
            <el-select v-model="editForm.dealerIdData" placeholder="请选择" multiple filterable style="width: 100%">
              <el-option
                v-for="item in dealerData"
                :key="item.userid"
                :label="item.name"
                :value="item.userid"
                clearable>
              </el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="及时纠错" prop="dIscorerr">-->
<!--            <el-radio v-model="editForm.dIscorerr" :label="0">关闭</el-radio>-->
<!--            <el-radio v-model="editForm.dIscorerr" :label="1">开启</el-radio>-->
<!--            <span style="font-size: 12px;color:#9aaabf" >-->
<!--              <i class=" el-icon-info"></i> 温馨提示：-->
<!--              <span>开启后学员在答题的时候能立刻看到答案</span>-->
<!--            </span>-->
<!--          </el-form-item>-->
          <el-form-item style="text-align: right">
            <el-button :loading="eidtLoading" type="primary" @click="SubForm('editForm')">立即提交</el-button>
            <el-button @click="dialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="考试指派详情"
      :visible.sync="viewVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="viewTableLoading">
        <el-table
          size="mini"
          :data="viewData"
          stripe
          style="width: 100%">
          <el-table-column
            label="名称"
            width="160"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="考试次数"
            width="160"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.dNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="考试得分"
            width="160"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.dScore}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="考试结果"
            width="180"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.dRes===0&&scope.row.dNum===0" :disable-transitions="true" size="mini" type="danger">未考试</el-tag>
              <el-tag v-if="scope.row.dRes===0&&scope.row.dNum>0" :disable-transitions="true" size="mini" type="danger">不及格</el-tag>
              <el-tag v-if="scope.row.dRes===1&&scope.row.dNum>0" :disable-transitions="true" size="mini" type="success">及格</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-button  v-if="scope.row.dNum>0" size="mini" @click.stop="examRecord(scope.row)" icon="el-icon-search">考试记录</el-button>
              <el-button  v-if="scope.row.dNum===0" size="mini" icon="el-icon-search" disabled>考试记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :title="examRecordTitle"
      :visible.sync="examRecordVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="examRecordTableLoading">
        <el-table
          size="mini"
          :data="examRecordData"
          stripe
          style="width: 100%">
          <el-table-column
            label="考试时间"
            width="180"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.dTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="考试得分"
            width="160"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.dScore}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="考试时长(分钟)"
            width="180"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.dDuration}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="考试结果"
            width="140"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.dRes===0" :disable-transitions="true" size="mini" type="danger">不及格</el-tag>
              <el-tag v-if="scope.row.dRes===1" :disable-transitions="true" size="mini" type="success">及格</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-button   size="mini" @click.stop="examRecordDetail(scope.row)" icon="el-icon-search">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="scoreDetailVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="scoreDetailLoading">
        <h3 align="center">{{ paperAddForm.name }}</h3>
        <div style="width: 100%;text-align: center;color: #666666;margin-bottom: 10px">{{ paperAddForm.remark }}</div>
        <div align="center"><span>出题人：{{ username }}</span><span style="margin-left: 20px">总题数：{{ count }}</span><span style="margin-left: 20px">总分数：{{ score }}</span></div>
        <div style="text-align: center;font-size: 12px;color:#9aaabf" >
          <i class="el-icon-info"></i> 说明：
          <span>蓝色为选择正确，红色为选择错误，绿色为正确答案</span>
        </div>
        <div v-for="problem in paperAddForm.problemForm" style="margin-left: 50px">
          <h4>{{ problem.xuhao }}、{{ problem.title }}（
            <span v-if="problem.type===0">单选题</span>
            <span v-if="problem.type===1">多选题</span>
            <span v-if="problem.type===2">判断题</span>
            ,{{ problem.score }}分）
          </h4>
          <div>
            <el-image
              v-for="img in problem.oldImgList"
              fit="cover"
              style="width: 60px; height: 60px;margin-right: 10px;"
              :src="img.url"
              :preview-src-list="problem.oldImgList.map(e=>e.url)"/>
          </div>
          <div v-if="problem.type===0||problem.type===2">
            <div v-for="option in problem.option" style="margin-top: 20px;">
              <span v-if="problem.trueOption===option.oxuhao&&problem.choose===option.oxuhao" style="color: #0099FF;font-weight: bold"><i class="el-icon-success"></i> {{option.val}}</span>
              <span v-if="problem.trueOption===option.oxuhao&&problem.choose!==option.oxuhao" style="color: #67C23A;font-weight: bold"><i class="el-icon-success"></i> {{option.val}}</span>
              <span v-if="problem.trueOption!==option.oxuhao&&problem.choose===option.oxuhao" style="color: #FF0000;font-weight: bold"><i class="el-icon-error"></i> {{option.val}}</span>
              <span v-if="problem.trueOption!==option.oxuhao&&problem.choose!==option.oxuhao" ><i class="el-icon-error"></i> {{option.val}}</span>
            </div>
          </div>
          <div v-if="problem.type===1">
            <div v-for="option in problem.option" style="margin-top: 20px">
              <span v-if="problem.trueOptions.indexOf(option.oxuhao)>=0&&problem.chooses.indexOf(option.oxuhao)>=0" style="color: #0099FF;font-weight: bold"><i class="el-icon-success"></i> {{option.val}}</span>
              <span v-if="problem.trueOptions.indexOf(option.oxuhao)>=0&&problem.chooses.indexOf(option.oxuhao)<0" style="color: #67C23A;font-weight: bold"><i class="el-icon-success"></i> {{option.val}}</span>
              <span v-if="problem.trueOptions.indexOf(option.oxuhao)<0&&problem.chooses.indexOf(option.oxuhao)>=0" style="color: #FF0000;font-weight: bold"><i class="el-icon-error"></i> {{option.val}}</span>
              <span v-if="problem.trueOptions.indexOf(option.oxuhao)<0&&problem.chooses.indexOf(option.oxuhao)<0" ><i class="el-icon-error"></i> {{option.val}}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  dealerEditExamTask,
  getMyExamTask,
  delExamTask,
  selectDealerList,
  getExamTaskDealerId,
  getExamTaskDetailZJY, getExamRecordZJY, getOptionRecordZJY
} from '@/api/work'
import PaperSelect from '@/components/PaperSelect'
import { getProblemListById } from '@/api/infoManage'
export default {
  name: 'delkszp',
  components: { PaperSelect },
  computed: {
    user: getUser
  },
  data() {
    return {
      username: '',
      count: 0,
      score: 0,
      type1: 0,
      type2: 0,
      type3: 0,
      paperAddForm: {
        paperid: 0,
        name: '',
        remark: '',
        ispub: 0,
        totalCount: null,
        totalScore: null,
        difficult: 1,
        passline: null,
        problemForm: []
      },
      problemForm: [{
        type: null,
        score: null,
        title: '',
        xuhao: 0,
        imgs: [],
        imgkey: '',
        oldImgList: [],
        trueOption: null,
        trueOptions: [],
        choose: null,
        chooses: [],
        optioncount: 1,
        option: [{
          oxuhao: null,
          val: ''
        }]
      }],
      scoreDetailVisible: false,
      scoreDetailLoading: false,
      examRecordData: [],
      examRecordTitle: '',
      examRecordVisible: false,
      examRecordTableLoading: false,
      viewData: [],
      viewVisible: false,
      viewTableLoading: false,
      dealerData: null,
      editFormLoading: false,
      searchForm: {
        dIsrepeat: null, // 允许重复考试
        dKeeptype: null, // 记分类型
        dAssign: null, // 指派类型
        dIscorerr: null, // 即时纠错
        search: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      radio: null,
      paperKey: '',
      editForm: {
        region: '',
        dealerIdData: [],
        dEtid: '', // 考试任务ID
        dName: '', // 任务名称
        timeSE: [], // 有效期
        dDuration: null, // 考试时长
        dPaperid: null, // 试卷ID
        dIsrepeat: 1, // 允许重复考试
        dKeeptype: 0, // 记分类型
        dAssign: 0, // 指派类型
        dTime: '', // 添加时间
        dIscorerr: 0, // 即时纠错
        oldPaperid: '' // 修改时候需要用的旧的试卷id
      },
      rules: {
        dName: [{ required: true, message: '请输入考试任务名称', trigger: 'blur' }],
        timeSE: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        dPaperid: [{ required: true, message: '请选择试卷', trigger: 'change' }],
        dealerIdData: [{ required: true, message: '请选择指定人员', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getData()
    this.getDealerList()
  },
  methods: {
    examRecordDetail(row) {
      this.scoreDetailVisible = true
      this.scoreDetailLoading = true
      this.paperAddForm.problemForm = []
      this.problemForm = []
      this.paperAddForm.name = row.paperName
      this.username = row.paperUsername
      this.paperAddForm.remark = row.paperRemark
      this.paperLoading = true
      let _choose = []
      const data = {
        ueid: row.dUeid
      }
      getOptionRecordZJY(data).then(response => {
        _choose = response.data
      }).then(() => {
        const data = {
          paperid: row.dPaperid
        }
        getProblemListById(data).then(response => {
          let index = 0
          let index2 = 0
          for (const problem of response.data) {
            this.problemForm.push({
              pid: problem.dPid,
              type: problem.dType,
              score: problem.dScore,
              title: problem.dTitle,
              xuhao: index + 1,
              trueOption: null,
              trueOptions: [],
              choose: null,
              chooses: [],
              optioncount: problem.optioncount,
              imgkey: new Date().getTime().toString() + index,
              imgs: [],
              oldImgList: [],
              option: []
            })
            for (const choose of _choose) {
              if (problem.dType === 0) {
                if (problem.dPid === choose.pid) {
                  this.problemForm[index].choose = choose.chooseXuhao
                }
              }
              if (problem.dType === 1) {
                if (problem.dPid === choose.pid) {
                  this.problemForm[index].chooses.push(choose.chooseXuhao)
                }
              }
              if (problem.dType === 2) {
                if (problem.dPid === choose.pid) {
                  this.problemForm[index].choose = choose.chooseXuhao
                }
              }
            }
            for (const img of problem.imgList) {
              this.problemForm[index].oldImgList.push({
                id: img.dImgid,
                url: img.img_url
              })
            }
            for (const option of problem.optionList) {
              this.problemForm[index].option.push({
                oxuhao: index2 + 1,
                val: option.dVal,
                pid: option.dPid,
                poid: option.dPoid
              })
              index2++
              if (problem.dType === 0 || problem.dType === 2) {
                if (option.dIstrue === 1) {
                  this.problemForm[index].trueOption = option.dXuhao
                }
              }
              if (problem.dType === 1) {
                if (option.dIstrue === 1) {
                  this.problemForm[index].trueOptions.push(option.dXuhao)
                }
              }
            }
            this.paperAddForm.problemForm.push(this.problemForm[index])
            index++
            index2 = 0
          }
          this.calNumber()
          this.scoreDetailLoading = false
        })
      }).catch(() => {
        this.scoreDetailLoading = false
      })
    },
    calNumber(index, type) {
      if (type === 0) {
        this.paperAddForm.problemForm[index].trueOption = 1
      }
      if (type === 1) {
        this.paperAddForm.problemForm[index].trueOptions = [1, 2]
      }
      if (type === 2) {
        this.paperAddForm.problemForm[index].trueOption = 1
      }
      let count = 0
      let score = 0
      let type1 = 0
      let type2 = 0
      let type3 = 0
      for (const problem of this.paperAddForm.problemForm) {
        count++
        score = score + parseInt(problem.score)
        if (problem.type === 0) {
          type1++
        } else if (problem.type === 1) {
          type2++
        } else if (problem.type === 2) {
          type3++
        }
      }
      this.count = count
      this.score = score
      this.type1 = type1
      this.type2 = type2
      this.type3 = type3
    },
    examRecord(row) {
      this.examRecordTitle = row.name + '考试记录'
      this.examRecordVisible = true
      this.examRecordTableLoading = true
      const data = {
        etid: row.dEtid,
        paperid: row.paperid,
        userid: row.dUserid,
        role: 1
      }
      getExamRecordZJY(data).then(response => {
        this.examRecordData = response.data
        this.examRecordTableLoading = false
      }).catch(() => {
        this.examRecordTableLoading = false
      })
    },
    view(row) {
      this.viewVisible = true
      this.viewTableLoading = true
      this.etid = row.d_etid
      const data = {
        etid: row.d_etid
      }
      getExamTaskDetailZJY(data).then(response => {
        this.viewData = response.data
        this.viewTableLoading = false
      }).catch(() => {
        this.viewTableLoading = false
      })
    },
    selectExamTaskDealerId(data) {
      getExamTaskDealerId(data).then(response => {
        this.editForm.dealerIdData = response.data
        this.editFormLoading = false
      })
    },
    getDealerList() {
      const data = {
        delid: this.user.delid
      }
      selectDealerList(data).then(response => {
        this.dealerData = response.data
      })
    },
    deleteRow(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          d_etid: row.d_etid,
          d_assign: row.d_assign
        }
        delExamTask(data).then(response => {
          this.getData()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        }).catch(() => {})
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    editRow(row) {
      this.editFormLoading = true
      if (row == null) {
        this.editTitle = '添加考试任务'
        this.dialogVisible = true
        this.paperKey = new Date().getTime()
        this.radio = 0
        //
        this.editForm.dPaperid = null
        this.editForm.dEtid = null// 考试任务ID
        this.editForm.dName = ''// 任务名称
        this.editForm.timeSE = [] // 有效期
        this.editForm.dDuration = 0 // 考试时长
        this.editForm.oldPaperid = '' // 试卷ID
        this.editForm.dIsrepeat = 0 // 允许重复考试
        this.editForm.dKeeptype = 0// 记分类型
        this.editForm.dAssign = 0 // 指派类型
        this.editForm.dIscorerr = 0 // 即时纠错，0代表关闭及时纠错
        this.editForm.dealerIdData = []
        this.editFormLoading = false
      } else {
        if (row.d_assign === 2) {
          const data = {
            dEtid: row.d_etid
          }
          this.selectExamTaskDealerId(data)
        } else {
          this.editForm.dealerIdData = []
          this.editFormLoading = false
        }
        this.editTitle = '修改考试任务'
        this.dialogVisible = true
        this.paperKey = new Date().getTime()
        this.editForm.dEtid = row.d_etid// 考试任务ID
        this.editForm.dName = row.d_name// 任务名称
        const time_SE = []
        if (row.d_starttime !== '0' && row.d_endtime !== '0') {
          this.radio = 1
          time_SE.push(row.d_starttime) // 有效期起
          time_SE.push(row.d_endtime) // 有效期止
          this.editForm.timeSE = time_SE
        } else {
          this.radio = 0
          this.editForm.timeSE = []
        }
        this.editForm.dDuration = row.d_duration // 考试时长
        this.editForm.oldPaperid = row.d_paperid // 试卷ID
        this.editForm.dIsrepeat = row.d_isrepeat // 允许重复考试
        this.editForm.dKeeptype = row.d_keeptype// 记分类型
        this.editForm.dAssign = row.d_assign // 指派类型
        this.editForm.dIscorerr = row.d_iscorerr // 即时纠错
      }
    },
    SubForm(formName) {
      if (!this.eidtLoading) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let startTime = ''
            let endTime = ''
            if (this.radio !== 0) {
              startTime = this.editForm.timeSE[0]
              endTime = this.editForm.timeSE[1]
            } else {
              startTime = 0
              endTime = 0
            }
            const data = {
              dEtid: this.editForm.dEtid, // 考试任务ID
              dName: this.editForm.dName, // 任务名称
              dStarttime: startTime,
              dEndtime: endTime,
              dDuration: this.editForm.dDuration, // 考试时长
              dPaperid: this.editForm.dPaperid, // 试卷ID
              dIsrepeat: this.editForm.dIsrepeat, // 允许重复考试
              dKeeptype: this.editForm.dKeeptype, // 记分类型
              dAssign: this.editForm.dAssign,
              dIscorerr: this.editForm.dIscorerr, // 即时纠错
              dUserid: this.user.userid,
              delid: this.user.delid,
              dealerIdData: this.editForm.dealerIdData.join(','),
              dRole: 1
            }
            this.eidtLoading = true
            dealerEditExamTask(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.getData()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      const data = {
        userid: this.user.userid,
        role: 1,
        page: this.currentPage,
        limit: this.pageSize,
        dIsrepeat: this.searchForm.dIsrepeat, // 允许重复考试
        dKeeptype: this.searchForm.dKeeptype, // 记分类型
        dAssign: this.searchForm.dAssign, // 指派类型
        dIscorerr: this.searchForm.dIscorerr, // 即时纠错
        search: this.searchForm.search
      }
      getMyExamTask(data).then(response => {
        this.tableData = response.data.data
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .kszp-main{
  }
</style>

